/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Linesheet_Not_Ready_For_SyncInputs */

const en_error_linesheet_not_ready_for_sync = /** @type {(inputs: Error_Linesheet_Not_Ready_For_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The linesheet is missing data required for the sync.`)
};

/**
* | output |
* | --- |
* | "The linesheet is missing data required for the sync." |
*
* @param {Error_Linesheet_Not_Ready_For_SyncInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_linesheet_not_ready_for_sync = /** @type {((inputs?: Error_Linesheet_Not_Ready_For_SyncInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Linesheet_Not_Ready_For_SyncInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_linesheet_not_ready_for_sync(inputs)
});